import React, { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import RightModalLayout from "../layouts/Modal/RightModalLayout";
import FastAnswersMC from "../modules/FastAnswers/FastAnswersMC";
import { SIDEBAR_ACTIONS } from "../../constants/actionsConstants";

const FastAnswersModal = memo(({ customer, platform, onSelectAnswer }) => {
  const dispatch = useDispatch();
  const closeModal = useCallback(() => {
      dispatch({
        type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR,
        payload: { componentKey: 'FastAnswersModal' }
      });
    }, [dispatch]);
    return (
  <div className="tw-wrapper">
    <RightModalLayout
      title="Respuestas Rápidas"
      closeAction={closeModal}
    >
      <FastAnswersMC
        currentCustomer={customer}
        platform={platform}
        onSelectAnswer={onSelectAnswer}
        closeModal={closeModal}
      />
    </RightModalLayout>
  </div>
);});

FastAnswersModal.displayName = "FastAnswersModal";

export default FastAnswersModal;
